module.exports = __webpack_public_path__ + "img/thumb-up-filled_2.8920c251.svg";